<div class="uk-section uk-section-secondary disclaimer">
  <div class="uk-container">
    <p>
      This website was built using <a href="http://angular.io">Angular</a> and <a href="https://getuikit.com">uikit framework</a>.
      All product and company names are trademarks™ or registered® trademarks of their respective holders.
    </p>
  </div>
  </div>